import {ThemeProvider} from 'styled-components';
import 'antd/dist/reset.css';
import './global.less';

export default ThemeProvider;
